import getParent from "@/utils/getParent";
import { merge } from "lodash";
import reporter from "../report/reporter";
import { getPage, getSearch } from "../shared/global";
import { MutiMng } from "./expose";
import { getFilter } from "./get";

const ContainerMng = new MutiMng({
  dataKey: "board_id",
  key: "board_source",
  reporterKeys: {
    ids: "board_ids",
    number: "board_number",
  },
});

export function board_expose(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33007,
    event_name: "board_expose",
    board_id: targetNode.getAttribute("data-board-id"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    trackData.board_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.board_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    const input = document.getElementById("hb_search_input");
    trackData.search_word = input?.value;
    trackData.search_word_type = getSearch().search_word_type;
  }

  if (page_nm === "专题页") {
    const el = document.querySelector("[data-topic-id]");
    if (el) {
      trackData.topic_title = el.getAttribute("data-topic-title");
      trackData.topic_id = el.getAttribute("data-topic-id");
    }
  }
  merge(trackData, getFilter(page.page_nm));

  ContainerMng.add(trackData);
}

export function board_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33008,
    event_name: "board_click",
    board_id: targetNode.getAttribute("data-board-id"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");
  if (sourceNode) {
    trackData.board_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.board_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    const input = document.getElementById("hb_search_input");
    trackData.search_word = input?.value;
    trackData.search_word_type = getSearch().search_word_type;
  }

  merge(trackData, getFilter(page.page_nm));

  reporter(trackData);
}
